import CenteredComponent from '../components/layouts/CenteredComponent';
import LoginPage from '../pages/auth/LoginPage';
import { Navigate, Route, Routes } from 'react-router';

const PublicRoutes = () => {
  return (
    <Routes>
      <Route path="*" element={<CenteredComponent />}>
        <Route path="login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Route>
    </Routes>
  );
};

export default PublicRoutes;
